<script>
    // @ts-nocheck

    import {
        Button,
        Typography,
        InputFile,
        Row,
        Column,
        InputText,
    } from '$lib/components/UI'
    import InputDate from '$lib/components/UI/InputDate.svelte'
    import PerceptionsTable from './PerceptionsTable.svelte'
    import { TrashOutline, AddOutline } from '$lib/components/Icons'
    import Edit from '$lib/components/Icons/custom/Edit.svelte'
    import Datatable from '$lib/components/UI/DatatableX.svelte'
    import Select from '$lib/components/UI/Select2.svelte'
    import dictionaries from '../../stores/dictionaries'
    import createDataStore from '../../stores/datastore'
    import { createEventDispatcher, onMount } from 'svelte'
    import { API_URL } from '$lib/conf'
    import { currencyFormatter } from '$lib/utils'
    export let value = {}
    export let allowMediaType = ['pdf']
    export let disabled = false
    export let valid = true
    export let preprocess = (x) => x
    const dispatch = createEventDispatcher()
    let percepcionesStore = createDataStore([])
    onMount(() => {
        if (value?.percepciones && value?.percepciones instanceof Array) {
            percepcionesStore.set(value.percepciones)
        }
    })
    let _value = structuredClone(value)
    let _valid = {}
    let loadPerceptions = false

    function onSubmit() {
        dispatch('submit', { ...value })
    }

    function validationDoc(d) {
        let rgx = new RegExp(`^.*\.(${allowMediaType.join('|')})$`, 'i')
        return (
            d instanceof Array &&
            d.length > 0 &&
            d.every((f) => rgx.test(f?.filename) || false)
        )
    }

    $: value = preprocess(_value)
    $: valid =
        Object.values(_valid).every((x) => x === true) &&
        !['', null, undefined].includes(_value.iva) &&
        !['', null, undefined].includes(_value.subtotal) &&
        !['', null, undefined].includes(_value.vencimiento_cae)
    $: console.log({ _valid })
</script>

<div>
    <Typography style="margin: 0">Subir Factura</Typography>
    <InputFile
        legend="Seleccione la factura."
        errMsg="Por favor cargue un documento en formato PDF"
        endpoint={`${API_URL}/upload`}
        style="flex-direction: row; justify-content: space-between; padding: 5px 15px"
        validation={validationDoc}
        bind:value={_value.file}
        bind:valid={_valid.file}
    />
    {#if loadPerceptions}
        <Typography type="subtitle">Percepciones</Typography>
        <PerceptionsTable bind:value={_value.percepciones} />
    {:else}
        <Button
            style="width:fit-content; margin: 0 auto"
            label="Cargar percepciones"
            size="small"
            on:click={() => (loadPerceptions = true)}
        >
            <AddOutline color="white" />
        </Button>
    {/if}
    <Row>
        <InputText
            {disabled}
            prefix="$"
            label="Subtotal sin impuestos ($)"
            bind:value={_value.subtotal}
            bind:valid={_valid.subtotal}
            validation={(v) =>
                v &&
                !['', null, undefined].includes(v) &&
                /^[0-9]+(\.[0-9]+)?$/.test(v) &&
                Number(v) > 0
            }
        />
        <InputText
            {disabled}
            prefix="$"
            label="Monto de IVA ($)"
            bind:value={_value.iva}
            bind:valid={_valid.iva}
            validation={(v) =>
                v &&
                !['', null, undefined].includes(v) &&
                /^[0-9]+(\.[0-9]+)?$/.test(v)}
        />
    </Row>
    <InputDate
        {disabled}
        label="Fecha de vencimiento del CAE"
        validation={(x) => x && !['', null, undefined].includes(x)}
        bind:value={_value.vencimiento_cae}
        bind:valid={_valid.vencimiento_cae}
    />
    <Button
        size="small"
        disabled={!valid || disabled}
        on:click={onSubmit}
        style="width: fit-content"
        label="Enviar factura"
    />
</div>

<style>
    div {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
</style>
